export const VERIFIED_USER = 'Verified buyer';
export const SIZE_LABEL = 'Size: ';
export const IMAGE_DIMENSION = 80;
export const USER_IMAGE_DIMENSION = 40;
export const DEFAULT_USER_IMAGE =
  'https://images-static.nykaa.com/fashion-nonprod-review/default_profile_image.svg';

export enum REVIEW_DETAILS_SOURCES {
  PDP_TOP_REVIEW_SECTION,
  PDP_IMAGE_GRID,
  ALL_REVIEW_PAGE,
  IMAGE_RAIL_ALL_REVIEW_SECTION,
  IMAGE_RAIL_PDP_SECTION,
}

export const REVIEW_DETAILS_SOURCES_VALUES = {
  [REVIEW_DETAILS_SOURCES.PDP_TOP_REVIEW_SECTION]: 'pdp:top_review_section',
  [REVIEW_DETAILS_SOURCES.PDP_IMAGE_GRID]: 'pdp:image_grid_view',
  [REVIEW_DETAILS_SOURCES.IMAGE_RAIL_PDP_SECTION]: 'pdp:image_gallery',
  [REVIEW_DETAILS_SOURCES.ALL_REVIEW_PAGE]: 'all_Review:review_section',
  [REVIEW_DETAILS_SOURCES.IMAGE_RAIL_ALL_REVIEW_SECTION]: 'all_Review:image_gallery',
};
